import { Button } from 'component/Button'
import { Image } from 'component/Image'
import { Gap, Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { renderItemTitle } from 'shared/item/title'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { ItemData } from 'type/Inference'
import css from './BuyCard.module.scss'

type Props = {
  item: ItemData
}

export const BuyCard = observer(({ item }: Props) => {
  const inference = store.inferences.buy!
  const { links, links_name, item_combo_image } = item
  const title = renderItemTitle(item)
  const disabled = !links

  const onBuy = useLatestCallback(() => {
    controller.openBuy(inference, item)
  })

  return (
    <Vertical className={css.root}>
      <Space wide pic>
        {item_combo_image && <Image src={item_combo_image} />}
      </Space>
      {title && <Gap height={12} />}
      {title}
      <Gap height={12} spring />
      <Button primary wide large action={onBuy} disabled={disabled}>
        {links_name || opt.buy_title}
      </Button>
    </Vertical>
  )
})
